export enum Category {
  AUTHENTICATION = 'AUTHENTICATION',
  TWO_MAN_RULE = 'TWO_MAN_RULE',
  PAYMENT = 'PAYMENT',
  MANAGEMENT = 'MANAGEMENT',
  FORECAST = 'FORECAST',
  ADMINISTRATION = 'ADMINISTRATION',
}
